import { ICancellationPolicy } from 'modules/settings/models';
import API from 'services/api';

export const getCancellationPolicy = (policyId: string | null): Promise<ICancellationPolicy> => {
  return API.get(`/api/accommodation/cancellation-policy/${policyId}`).then(res => res?.data);
};
